import { defineStore } from 'pinia'

import {ref, unref, computed, reactive, toRaw} from 'vue'

export const CUSTOMER_CABIN_ID = -1
import {SID_CUSTOMER} from '@/tourist/tourist-store.js'
import {precalc} from '@/comp/precalc.js'
import {debounce} from '@/util.js'
import {save_localStorage} from '@/localStor.js'

const getOccupancyItem = ({adult, child, infant}) => {
    adult = adult || 0
    child = child || 0
    infant = infant || 0
    return {
        adult,
        child,
        infant,
        adultChild: `${adult}.${child}`
    }
}

// передаем acc = {main, additional}; getOccupancyList( acc )
const getOccupancyList = ({main, additional}) => {
    const total = main + additional
    const ret = []
    for (let adult = 1; adult <= total; adult++) {
        for (let child = 0; child <= total-adult ; child++) {
            ret.push( {adult, child, adultChild: `${adult}.${child}`} )
        }
    }
    return ret
}

const customerCabinPlace = {
    pnum: 0,
    ttype: 'cr-adult',
    itype: 'cr-adult',
}


const getOccupancyPlaces = ({adult, child, infant}) => {
    const a = Array.from({length: adult}).map( () => {
        return {
            ttype: 'cr-adult',
            itype: 'cr-place',
        }
    })
    const b = Array.from({length: child}).map( () => {
        return {
            ttype: 'cr-child',
            itype: 'cr-place',
        }
    })
    const c = Array.from({length: infant}).map( (_,ind) => {
        return {
            pnum: 0 - 1 - ind,
            ttype: 'cr-infant',
            itype: 'cr-infant',
        }
    })
    const ret = a.concat(b).map( (ob, pnum) => {
        return {
            ...ob,
            pnum,
        }
    } ).concat(c)
    return ret
}

export default defineStore('bookCabins', () => {
    const precalcId = 'book'
    const bookBox= ref({})
    const precalcBox = ref({})
    let LS_KEY = ''

    /**************************
     * загружаем данный отдельного круиза
     * случится только если закрылась вкладка  
     * грузим cabins, persons, occ
     *   [ {id, adult, child, infant, acc }  ] - id - cabinId
     */
    const saveLocalStorage = (key) => {
        LS_KEY = key
    }

    // const {loaded, cabins, persons, occlist} = load( cruiseIdFull )
    const load = cruiseIdFull => {
        let loaded = false
        let {cabins, persons, occlist} = {}
        let notes = notes_default()
        if (LS_KEY) {
            const lsKey = `${LS_KEY}.${cruiseIdFull}`
            let vals
            try {
                const str = window.localStorage.getItem( lsKey )
                if (str) {
                    vals = JSON.parse( str )
                }

                if (vals) {
                    cabins = vals.cabins
                    persons = vals.persons
                    occlist = vals.occlist
                    if (vals.notes && 'object' === typeof(vals.notes) ) {// TODO: делать проверку по схеме
                        notes = vals.notes
                    } 
                    if (cabins.length === occlist.length && cabins.length>0 && Array.isArray(persons)) {
                        loaded = true
                    }
                }
            } catch (e) {
                console.error(`bookCabins.load ${lsKey}`, e)
            }
        }
//console.log('load', loaded, cabins, persons, occlist)
        return {loaded, cabins, persons, occlist, notes}
    }
    const save = () => {
        if (!LS_KEY) {
            return
        }
        const {cabins, persons, occupancy, cruiseIdFull, notes} = unref(bookBox)
        const lsKey = `${LS_KEY}.${cruiseIdFull}`
        const occlist = Object.entries(occupancy).map( ([_, {id, adult, child, infant, acc}])=>{
            return {id, adult, child, infant, acc}
        } ).filter( ob => Boolean( cabins.find( cab => cab.id === ob.id ) )  )
        const vals = { cabins, persons, occlist, notes }
        save_localStorage(lsKey, vals)
    }
    const save_debounce = debounce( save, 1000 )

    const clean = () => {
        if (LS_KEY) {
            const {cruiseIdFull} = unref(bookBox)
            if (cruiseIdFull) {
                const lsKey = `${LS_KEY}.${cruiseIdFull}`
                window.localStorage.removeItem(lsKey)
            }
        }
        bookBox.value = {}
        precalcBox.value = {}
    }

    const notes_default = () => {
        const ret =  {
            note: '', // Примечание к заказу
            attachDoc: false, // При клике выходит прикрепите соответствующий документ
        }
        return ret
    }

    const initBookBox = ({cruiseIdFull, ages, roomsMap, tstore_sids, key, tstore_sids_only, max_cabins}) => {
//console.log('initBookBox', cruiseIdFull, ages, roomsMap, tstore_sids, key, tstore_sids_only)
        let old = unref(bookBox)
        if (old.cruiseIdFull !== cruiseIdFull) {
            const newBox = {
                cruiseIdFull,
                cabins: [],
                persons: [],
                ages: ages || {}, // необязателен для отладки, в рабочем режиме всегда есть
                max_cabins: max_cabins || 1,
                occupancy: {},
                key, 
                notes: notes_default(),
            }
            let {loaded, cabins, persons, occlist, notes} = load( cruiseIdFull )
            if (loaded) {
                let occentries = occlist.map( ({id, adult, child, infant, acc }) => {
                    const occrec = getOccupancyItem( { adult, child, infant })
                    const places = getOccupancyPlaces( occrec )
                    const rec = {
                        ...occrec,
                        places,
                        acc,
                        id,
                    }
                    return [id, rec]
                })
                if (roomsMap) {// необязателен для отладки, в рабочем режиме всегда есть
                    cabins = cabins.filter( ( { id } ) => roomsMap[ id ]  )
                    occentries = occentries.filter( ( [ id ] ) => roomsMap[ id ] ).map( ([ id, ob ]) => {
                        const { acc } = roomsMap[ id ]
                        return [ id, {...ob, acc } ]
                    } )
                }
                if (tstore_sids) {
                    persons = persons.filter( 
                        p => SID_CUSTOMER === p.sid
                        || ( tstore_sids.includes( p.sid ) && roomsMap[p.cabinId] )
                    )
                }
                if (tstore_sids_only) {
                    persons = persons.filter( 
                        p => SID_CUSTOMER === p.sid
                        || tstore_sids_only.includes( p.sid )
                    )
                }
                const occupancy = Object.fromEntries( occentries )
                bookBox.value = {
                    ...newBox,
                    cabins, 
                    persons, 
                    occupancy,
                    notes,
                }
            } else {
                bookBox.value = newBox
            }
            precalcBox.value = {}
        } else {
            if (ages) {
                bookBox.value.ages = ages
            }
            if (max_cabins) {
                bookBox.value.max_cabins = max_cabins
            }
        }
        if (!bookBox.value.persons.find( ob => ob.cabinId === CUSTOMER_CABIN_ID )) {
            bookBox.value.persons.push( { 
                cabinId: CUSTOMER_CABIN_ID,
                pnum: 0,
                itype: "cr-adult",
                sid: SID_CUSTOMER,
            } )
        }
    }


    const initCabinPrecalc = cabinId => {
        const old = unref(precalcBox)
        if (!(cabinId in old)) {
            const {cruiseIdFull, key, occupancy} = unref(bookBox)
            const target = `cabin-${cabinId}`
            const precalc_item = precalc({cruiseIdFull, key , target})
            const {places} = occupancy[ cabinId ] // нужно ли  проверку?
            precalc_item.set_cabinOccupation( {cabinId, places} )
            precalcBox.value = {...old, [cabinId]: precalc_item  }
        }
    }
    const updateCabinPrecalc = cabinId => {
        const old = unref(precalcBox)
        const precalc_item = old[ cabinId ]
        const {occupancy} = unref(bookBox)
        const {places} = occupancy[ cabinId ] // нужно ли  проверку?
        precalc_item.set_cabinOccupation( {cabinId, places} )
    }

    const getPrecalc = cabinId => computed(()=>{
        let ret = null
        const old = unref(precalcBox)
        if (cabinId in old) {
            const precalc_item = old[ cabinId ]
            const calc = precalc_item.get()
            let first = null
            if (calc.ok && calc.acc) {
                const cab0 = Object.values(calc.calc_prices)[0]
                first = { ...cab0, src: calc.src,  }
            }
            ret = {calc, first}
        }
        return ret
    })

    const initBookPrecalc = (stores) => {
        const old = unref(precalcBox)
        if (!(precalcId in old)) {
            const {cruiseIdFull, key} = unref(bookBox)
            const target = "book"
            const precalc_item = precalc({cruiseIdFull, key , target})
            precalcBox.value = {...old, [precalcId]: precalc_item  }
            updateBookPrecalc(stores)
        } else {
            updateBookPrecalc(stores)
        }
    }
    const updateBookPrecalc = stores => {
        const old = unref(precalcBox)
        const precalc_item = old[ precalcId ]
        if (precalc_item) {
            precalc_item.set_bookCabins( stores )
        }
    }
    const getBookPrecalc = () => computed(()=>{
        let ret = null
        const old = unref(precalcBox)
        if (precalcId in old) {
            const precalc_item = old[ precalcId ]
            const calc = precalc_item.get()
            let cabs = {}
            if (calc.ok && calc.acc) {
                let entr = Object.entries(calc.calc_prices).map( 
                    ([key, prices]) => [key, {...prices, src: calc.src}]  
                )
                cabs = Object.fromEntries( entr )
            }
            ret = {calc, cabs}
        }
        return ret
    })

    const initBookBoxCabin = ( { cabinId, acc } ) => {
        let old = unref(bookBox).occupancy
        if (cabinId in old) {
        } else {
            const occrec = getOccupancyItem( { adult: acc.main })
            const places = getOccupancyPlaces( occrec )
            const ob = {
                ...occrec,
                places,
                acc,
                id: cabinId
            }
            bookBox.value.occupancy = {...old, [cabinId]: ob}
        }
    }

    const bookUnbook = ( {  cabinId } ) => {
        const {cabins} = unref(bookBox)
        let nov 
        if (cabins.find( ob => ob.id === cabinId )) {
            nov = cabins.filter( ob => ob.id !== cabinId )
        } else if (mayBook()) {// нельзя бронировать больше максимума!
            let item = {
                id: cabinId,
                ord: Date.now(), 
            }
            nov = [...cabins, item]
        }

        if (nov) {
            bookBox.value.cabins = nov
            save()
        }
    }

    const notEmpty = () => {
        const {cabins} = unref(bookBox)
        const ret = Boolean(cabins && cabins.length)
        return ret
    }

    const isBooked = cabinId => {
        let ret = false
        const {cabins} = unref(bookBox)
        if (cabins) {
            ret = Boolean( cabins.find( ob => ob.id === cabinId) )
        }
        return ret
    }

    const setInfant = ( { cabinId, infant } ) => {
        const old = unref(bookBox).occupancy[ cabinId ]
        const {adult, child} = old
        setOccupation(  { cabinId, infant, adult, child  } )
    }
    const setOccRec = ( { cabinId, adultChild } ) => {
        const old = unref(bookBox).occupancy[ cabinId ]
        const {infant} = old
        const [adult, child] = adultChild.split('.').map( v => parseInt(v,10)  )
        setOccupation(  { cabinId, infant, adult, child  } )
    }

    const setOccupation = ( { cabinId, infant, adult, child  } ) => {
        const {acc} = unref(bookBox).occupancy[ cabinId ]
        const occrec = getOccupancyItem( { adult, child, infant  })
        const places = getOccupancyPlaces( occrec )
        const ob = {
            ...occrec,
            places,
            acc,
            id: cabinId
        }
        bookBox.value.occupancy[ cabinId ] = ob
        correctPersons( { cabinId } )
        save()
    }

    const correctPersons = ( { cabinId }) => {
        const { persons  } = unref( bookBox )
        const { places }  = unref( bookBox ).occupancy[ cabinId ]

        const places_valid = ( { itype, pnum } ) => {
            const p = places.find( ob => ob.pnum === pnum )
            const valid = p && p.itype === itype
            return Boolean( valid )
        }

        const nov = persons.filter( ob => ob.cabinId !== cabinId || places_valid( ob )   )
        bookBox.value.persons = nov
    }

    const getOccupation = cabinId  => computed(() => {
        const cabinOccupation = unref(bookBox).occupancy[ cabinId ] 
        let ret = false
        if (cabinOccupation) {
            const {ages, max_cabins} = unref(bookBox)
            const list = getOccupancyList( cabinOccupation.acc )
            const {infant, adult, child, adultChild} = cabinOccupation
            ret = {
                list,
                infant,
                adult,
                child, 
                adultChild,
                ages,
                max_cabins,
                mayBook: mayBook(),
            }
        }
        return ret
    })

    const mayBook = () => {
        const {max_cabins, cabins} = unref(bookBox)
        const ret = cabins.length < max_cabins
        return ret
    }

    const customerCabinId = CUSTOMER_CABIN_ID

    const personItem = (cabinId, place) => computed({
        get() {
//console.log('personItem get', cabinId, place)
            let {pnum, itype} = place
            let item = unref(bookBox).persons.find( ob => ob.cabinId === cabinId && ob.pnum === pnum  )
            if (!item) {
                item = {
                    cabinId,
                    pnum, 
                    itype,
                    sid: '',
                }
            }
            return item
        }, 
        set(sid) {
            let {persons} = unref(bookBox)
            let {pnum, itype} = place
            persons = persons.filter( ob => ob.sid !== sid ) // чтобы не допустить дублей
            const nov = {
                    cabinId,
                    pnum, 
                    itype,
                    sid,
            }
            persons.push(nov)
            bookBox.value.persons = persons
            save()
        }
    })

    const notes_attachDoc = computed({
        get () {
            let ret = unref( bookBox ).notes.attachDoc ? '1' : ''
            return ret
        },
        set(val) {
            let newVal = Boolean(val)
            bookBox.value.notes.attachDoc = newVal
            save()
        },
    })

    const notes_note = computed({
        get () {
            let ret = unref( bookBox ).notes.note
            return ret
        },
        set(val) {
            let newVal = val || '' // защита от нулей undefined и т.д.
            bookBox.value.notes.note = newVal
            save_debounce()
        },
    })

    const notes_for_book = () => {
        const {note, attachDoc} = unref( bookBox ).notes
        let ret = note
        if (attachDoc) {
            ret = `${ret}\nЗапрашиваю пенсионную скидку`
        }
        return ret
    }

    const getUsedSids = () => {
        const {persons} = unref(bookBox)
        const sids = persons.map( ({sid}) => [ sid, sid ] )
        const ret = Object.fromEntries(sids)
        return ret
    }
    const getAdultSids = (with_place = true) => {
        const {persons} = unref(bookBox)
        let filter_func
        if (with_place) {
            filter_func = ({itype,sid}) => itype==='cr-place' && sid!==SID_CUSTOMER
        } else {
            filter_func = ({itype,sid}) => sid!==SID_CUSTOMER
        }
        const sids = persons.filter(filter_func).map( ({sid}) => sid )
        return sids
    }

    return {
        getUsedSids,
        personItem, 
        bookBox,
        initBookBox, 
        initBookBoxCabin,
        bookUnbook,
        isBooked,
        setInfant,
        setOccRec,
        setOccupation,
        correctPersons,
        getOccupation,
        notEmpty,
        saveLocalStorage,
        customerCabinId,
        customerCabinPlace,

        precalcBox,
        initCabinPrecalc,
        updateCabinPrecalc,
        getPrecalc,

        initBookPrecalc,
        updateBookPrecalc,
        getBookPrecalc,

        notes_note,
        notes_attachDoc,
        notes_for_book,

        getAdultSids,

        clean,

    }

})
